// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_qo-0";